// axios
import axios from 'axios';
// routes
import {routes} from "../../../features/routes/route";
// config
import {AuthConfig2} from "../../../config/authConfig";

export const SetUserRef = async (data: any) => {
    const {data: response} = await axios.post(`${routes.api[1].address_3}`, data, AuthConfig2);
    return response;
};
